import { useState } from 'react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { toast } from 'sonner';
import { Mail, Loader2 } from 'lucide-react';
import authService from '../services/auth.service';

interface ResendVerificationProps {
  onClose: () => void;
}

export function ResendVerification({ onClose }: ResendVerificationProps) {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!email) {
      toast.error('Please enter your email address');
      return;
    }

    setLoading(true);
    try {
      await authService.resendVerificationEmail(email);
      toast.success('Verification email sent! Please check your inbox.');
      onClose();
    } catch (error: any) {
      toast.error(error.message || 'Failed to send verification email');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-4">
      <div className="text-center">
        <Mail className="mx-auto h-12 w-12 text-[#d4af37] mb-4" aria-hidden="true" />
        <h3 className="text-lg font-semibold text-gray-900">Resend Verification Email</h3>
        <p className="text-sm text-gray-600 mt-2">
          Enter your email address and we'll send you a new verification link.
        </p>
      </div>

      <form onSubmit={handleSubmit} className="space-y-4">
        <div className="space-y-2">
          <Label htmlFor="resend-email">Email Address</Label>
          <Input
            id="resend-email"
            type="email"
            placeholder="your.email@example.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>

        <div className="flex gap-3">
          <Button
            type="submit"
            variant="gold"
            disabled={loading}
            className="flex-1"
          >
            {loading ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                Sending...
              </>
            ) : (
              'Send Verification Email'
            )}
          </Button>
          <Button
            type="button"
            variant="outline"
            onClick={onClose}
            disabled={loading}
          >
            Cancel
          </Button>
        </div>
      </form>
    </div>
  );
}
